module.exports = __webpack_public_path__ + "dict/img/person.f70c1c9f.png";